export const ActiveMenuItemId = Object.freeze({
	AdvancedSearch: 'advancedSearch',
	Search: 'search',
	DatePrinted: 'datePrinted',
	EligibleFor: 'eligibleFor',
	Status: 'status',
	User: 'user',
});
